module.exports = __webpack_public_path__ + "img/dep_drinks.9f2edcec.png";